import { message } from "antd";

export const RATE_LIMIT_ERROR_MESSAGE =
  "You're doing that too quickly. Please wait a few seconds before trying again.";

const RATE_LIMIT_MESSAGE_KEY = "graphql-rate-limit";
const RECENT_RATE_LIMIT_WINDOW_MS = 30_000;

let lastRateLimitErrorAt: number | undefined;

export const getNetworkErrorStatusCode = (
  networkError: unknown
): number | undefined => {
  if (!networkError || typeof networkError !== "object") return undefined;

  const { statusCode } = networkError as { statusCode?: unknown };
  return typeof statusCode === "number" ? statusCode : undefined;
};

export const isRateLimitError = (networkError: unknown): boolean =>
  getNetworkErrorStatusCode(networkError) === 429;

export const wasRateLimitErrorRecently = (): boolean =>
  lastRateLimitErrorAt !== undefined &&
  Date.now() - lastRateLimitErrorAt < RECENT_RATE_LIMIT_WINDOW_MS;

export const showRateLimitError = () => {
  lastRateLimitErrorAt = Date.now();

  return message.error({
    content: RATE_LIMIT_ERROR_MESSAGE,
    duration: 6,
    key: RATE_LIMIT_MESSAGE_KEY,
  });
};
